import { render } from "./ShimmerImage.vue?vue&type=template&id=20e702d4&scoped=true"
import script from "./ShimmerImage.vue?vue&type=script&lang=js"
export * from "./ShimmerImage.vue?vue&type=script&lang=js"

import "./ShimmerImage.vue?vue&type=style&index=0&id=20e702d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e702d4"]])

export default __exports__